import { z } from "zod";

export const createBankAccountSchema = z.object({
  name: z.string({ invalid_type_error: "Name must be a string" }).min(1, { message: "Name cannot be empty" }),
  country: z.string({ invalid_type_error: "Country must be a string" }).min(1, { message: "Country cannot be empty" }),
  currency: z
    .string({ invalid_type_error: "Currency must be a string" })
    .min(1, { message: "Currency cannot be empty" }),
  iban: z.string({ invalid_type_error: "IBAN must be a string" }).min(1, { message: "IBAN cannot be empty" }),
  isDefault: z.boolean({ invalid_type_error: "isDefault must be a boolean" }),
  organizationId: z.string({ invalid_type_error: "Organization ID must be a string" }).optional().nullable(),
  relationId: z.string({ invalid_type_error: "Client ID must be a string" }).optional().nullable(),
});

export const updateBankAccountSchema = createBankAccountSchema.partial().extend({
  id: z.string({ invalid_type_error: "ID must be a string" }),
});

export const deleteBankAccountSchema = z.object({
  id: z.string({ invalid_type_error: "ID must be a string" }),
});

export const setDefaultBankAccountSchema = z.object({
  id: z.string({ invalid_type_error: "ID must be a string" }),
  organizationId: z.string({ invalid_type_error: "Organization ID must be a string" }),
});

export type ZodCreateBankAccountSchema = z.infer<typeof createBankAccountSchema>;
export type ZodUpdateBankAccountSchema = z.infer<typeof updateBankAccountSchema>;
export type ZodDeleteBankAccountSchema = z.infer<typeof deleteBankAccountSchema>;
export type ZodSetDefaultBankAccountSchema = z.infer<typeof setDefaultBankAccountSchema>;

export const bankAccountSchema = z.object({
  id: z.string(),
  name: z.string(),
  country: z.string(),
  currency: z.string(),
  iban: z.string(),
  isDefault: z.boolean(),
  organizationId: z.string().nullable(),
  relationId: z.string().nullable(),
  createdAt: z.date(),
  updatedAt: z.date(),
  userId: z.string(),
});

export type BankAccountSchema = z.infer<typeof bankAccountSchema>;

export const createBankAccountSchemaDefaultValues: ZodCreateBankAccountSchema = {
  name: "",
  country: "",
  currency: "",
  iban: "",
  isDefault: false,
  organizationId: undefined,
  relationId: undefined,
};
